import { Row, Col, Form, InputNumber, Slider, Button } from 'antd';

interface Props {
	value: [number, number];
	initialRange: [number, number];
	onChange: (value: [number, number]) => void;
	onApply: () => void;
	step?: number;
	suffix?: string;
	/** Compact mode for tablet/horizontal layouts */
	compact?: boolean;
}

export const RangeFilter = ({
	value,
	initialRange,
	onChange,
	onApply,
	step = 0.25,
	suffix = 'in',
	compact = false,
}: Props) => {
	const handleMinChange = (v: number | null) => {
		if (v !== null) onChange([Number(v), value[1]]);
	};

	const handleMaxChange = (v: number | null) => {
		if (v !== null) onChange([value[0], Number(v)]);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter') onApply();
	};

	if (compact) {
		return (
			<div style={{ width: 200 }}>
				<div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
					<InputNumber
						size="small"
						min={initialRange[0]}
						max={initialRange[1]}
						step={step}
						value={value[0]}
						onChange={handleMinChange}
						onKeyDown={handleKeyDown}
						style={{ width: 75 }}
						suffix={suffix}
					/>
					<span style={{ fontSize: 12, color: '#999' }}>–</span>
					<InputNumber
						size="small"
						min={initialRange[0]}
						max={initialRange[1]}
						step={step}
						value={value[1]}
						onChange={handleMaxChange}
						onKeyDown={handleKeyDown}
						style={{ width: 75 }}
						suffix={suffix}
					/>
					<Button size="small" type="primary" onClick={onApply}>
						Go
					</Button>
				</div>
				<Slider
					range
					min={initialRange[0]}
					max={initialRange[1]}
					step={step}
					value={value}
					onChange={(val) => onChange([val[0], val[1]])}
					tooltip={{ formatter: (v) => `${v}"` }}
					style={{ margin: '4px 0 0 0' }}
				/>
			</div>
		);
	}

	return (
		<Row gutter={8} align="middle">
			<Col span={12}>
				<Form.Item label="Min">
					<InputNumber
						min={initialRange[0]}
						max={initialRange[1]}
						step={step}
						value={value[0]}
						onChange={handleMinChange}
						onKeyDown={handleKeyDown}
						style={{ width: '100%' }}
						suffix={suffix}
					/>
				</Form.Item>
			</Col>
			<Col span={12}>
				<Form.Item label="Max">
					<InputNumber
						min={initialRange[0]}
						max={initialRange[1]}
						step={step}
						value={value[1]}
						onChange={handleMaxChange}
						onKeyDown={handleKeyDown}
						style={{ width: '100%' }}
						suffix={suffix}
					/>
				</Form.Item>
			</Col>
			<Col span={24}>
				<Slider
					range
					min={initialRange[0]}
					max={initialRange[1]}
					step={step}
					value={value}
					onChange={(val) => onChange([val[0], val[1]])}
					tooltip={{ formatter: (v) => `${v}"` }}
				/>
			</Col>
			<Col span={24} style={{ marginTop: 10 }}>
				<Button type="primary" block onClick={onApply}>
					Apply
				</Button>
			</Col>
		</Row>
	);
};